import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e6d0bea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "home_content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "报名信息")
], -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("未支付")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("已支付")
const _hoisted_6 = { class: "bottom" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("确定支付")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("返回")

import { ref, onMounted } from 'vue'
  import {GETAuth} from '@/service/index'
  import {useRouter} from 'vue-router'
  import {ElMessage, ElMessageBox} from 'element-plus'
  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const router = useRouter()
  const loading = ref(false)
  const isPay = ref(false)

  const recordBase:any = ref([])

  onMounted(() => {
    const { params: { record } } = router.currentRoute.value
    getRecord(record)
  })

  const getRecord = async (recordcode:any) => {
    recordBase.value = {}
    let { data } = await GETAuth(`/api/enroll_record/${recordcode}`)
    if ( data.code === 200 ) {
      recordBase.value = [data.data]
      if ( data && data.data && data.data.errollstatus === "APPROVED" ) {
        isPay.value = true
      } else {
        isPay.value = false
      }
    }
  }

  const backHandler = () => {
    router.go(-1)
  }

  const submitAsync = async () => {
    const { params: { record } } = router.currentRoute.value
    loading.value = true
    let { data } = await GETAuth(`/api/enroll_record_paid/${record}`)
    loading.value = false
    if ( data.code === 200 ) {
      getRecord(record)
    } else {
      ElMessage.error(data.msg)
    }
  }
  

  const onSubmit = async () => {
    ElMessageBox.confirm(
      '确定该报名记录已支付吗？',
      '提示',
      {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }
    )
    .then(() => {
      submitAsync();
    })
  }


return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_card, { class: "box-card" }, {
        header: _withCtx(() => [
          _hoisted_3
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  (recordBase.value.length)
                    ? (_openBlock(), _createBlock(_component_el_table, {
                        key: 0,
                        "show-overflow-tooltip": "",
                        stripe: "",
                        data: recordBase.value
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_table_column, {
                            prop: "studentname",
                            label: "姓名"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "idcardname",
                            label: "证件类型"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "idcardno",
                            label: "证件号"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "coursename",
                            label: "报名课程"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "errollstatus",
                            label: "支付状态"
                          }, {
                            default: _withCtx((scope) => [
                              (scope.row.errollstatus === 'APPROVED')
                                ? (_openBlock(), _createBlock(_component_el_tag, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _hoisted_4
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (scope.row.errollstatus === 'PAID')
                                ? (_openBlock(), _createBlock(_component_el_tag, {
                                    key: 1,
                                    type: "success"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_5
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["data"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_6, [
                    (isPay.value)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "primary",
                          size: "large",
                          loading: loading.value,
                          onClick: onSubmit
                        }, {
                          default: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 1
                        }, 8, ["loading"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_button, {
                      size: "large",
                      onClick: backHandler
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})